import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import DtnService from '../../../services/DtnService';
import { snakeCaseToTitle } from '../../../utils/Helpers';
import moment from 'moment';
import FormInputText from '../../_shared/forms/FormInputText';
import FormCheckbox from '../../_shared/forms/FormCheckbox';
import DatePicker from 'react-datepicker';
import FormError from '../../_shared/forms/FormError';
import FormMultiSelect, { SearchableSelect } from '../../_shared/forms/FormMultiSelect';
import JobExtras from '../JobExtras';
import DtnPhotos from './paritals/DtnPhotos';
import SubmitButton from '../../_shared/SubmitButton';
import DriverSignature from './paritals/DriverSignature';
import PricingDetails from './paritals/PricingDetails';
import StatusButtons from './paritals/StatusButtons';
import FormInputNumber from '../../_shared/forms/FormInputNumber';
import CustomerDetails from './paritals/CustomerDetails';
import OperativeDetails from './paritals/OperativeDetails';
import RecycledWasteChart from '../recycle/RecycledWasteChart';

class EditVolumeJobs extends Component {
    constructor(props) {
        super(props);
        let { job, dtn, type } = this.props;

        this.recycledWasteRef = React.createRef();
        let collectionDate = dtn.collection_date ? new Date(dtn.collection_date) : '';
        let beforeLoadingWaste = type.before_loading_waste
            ? new Date(type.before_loading_waste)
            : new Date('2023-08-25 10:05:00');
        let afterLoadingWaste = type.after_loading_waste
            ? new Date(type.after_loading_waste)
            : new Date('2023-08-25 10:38:00');
        let jobNotes = dtn.job_notes !== 'no' ? dtn.job_notes : '';

        let tipOffOptions = [...this.props.tipOffOptions];

        let tipOff = tipOffOptions.find((tipOff) => {
            return tipOff.value === this.props.job.tip_off_id;
        });

        const hasRecycledWaste = !!this.props.hasRecycledWaste;
        const customerUsesRecycling = !!this.props.customerUsesRecycling;

        this.state = {
            address: job.address_line_1 || '',
            postcode: job.postcode || '',
            collection_date: collectionDate,
            before_loading_waste: beforeLoadingWaste,
            after_loading_waste: afterLoadingWaste,
            job_notes: jobNotes || '',
            waste_collected: type.waste_collected,
            waste_contained: type.waste_contained || 'Loose',
            waste_description: type.waste_description || 'General Mixed Waste 20 03 01',
            waste_volume: type.waste_volume,
            extrasOptions: this.props.jobExtras || '',
            selectedExtras: job.job_extras || '',
            jobTypePrice: 0,
            additionalCosts: this.props.additionalCosts || '',
            totalPrice: 0,
            providerJobTypePrice: 0,
            providerTotalPrice: 0,
            loading: false,
            images_before: '',
            images_after: '',
            van_images_before: '',
            van_images_after: '',
            customer_signature: '',
            rejected_files: {},
            errors: {},
            tipOff: typeof tipOff !== 'undefined' ? tipOff : [],
            hasRecycledWaste,
            customerUsesRecycling,
            recycledWasteValid: hasRecycledWaste,
            recycledWasteSaved: hasRecycledWaste,
            savingRecycledWaste: false,
            provider_quantity: job.provider_quantity || 0,
            quantity: job.quantity || 0,
            admin_notes: job.admin_notes || '',
            purchase_order_number: job.purchase_order_number || '',
            purchase_order_total: job.purchase_order_total || 0,
            sla: job.sla || '',
            price_quoted: job.price_quoted === 1 ? 'yes' : 'no',
            custom_price: job.custom_price || 0,
            custom_price_with_vat: job.custom_price ? job.custom_price * 1.2 : 0,
            disable_status_buttons: false,
            provider_price_quoted: job.provider_price_quoted === 1 ? 'yes' : 'no',
            provider_custom_price: job.provider_custom_price || '',
            provider_custom_price_with_vat: job.provider_custom_price ? job.provider_custom_price * 1.2 : '',
            route_started: '',
            route_arrived: '',
            first_operative: {},
            second_operative: {},
            job_completed: '',
            manager_review: job.manager_review === 1 ? 'yes' : 'no',
            manager_review_reason: job.manager_review_reason || '',
            created_by: job.created_by ? job.created_by : '',
        };
        this.dtnService = new DtnService();
    }

    componentDidMount() {
        let jobTypePrice = this.setJobTypePrice();
        let providerJobTypePrice = this.setProviderJobTypePrice();

        this.calculateTotalPrice(jobTypePrice, providerJobTypePrice);

        if (this.state.customerUsesRecycling && this.state.hasRecycledWaste) {
            this.setState({
                recycledWasteValid: true,
                recycledWasteSaved: true,
                savingRecycledWaste: false,
            });
        }
    }

    jobNotTippedModal = () => {
        window.swal.fire({
            title: `Waste not tipped`,
            text: ``,
            type: 'info',
            confirmButtonText: `Ok`,
        });
    };

    setJobTypePrice = () => {
        let jobType = this.props.jobTypes.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });

        let jobTypePrice = jobType.pivot ? jobType.pivot.price : jobType.default_price;

        this.setState({
            jobTypePrice: jobTypePrice,
        });

        return jobTypePrice;
    };

    setProviderJobTypePrice = () => {
        let providerJobType = this.props.serviceProvider.job_types.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });
        let providerJobTypePrice;

        //If provider does not have job type available, use global job type default price
        if (typeof providerJobType !== 'undefined') {
            providerJobTypePrice = providerJobType.pivot ? providerJobType.pivot.price : providerJobType.default_price;
        } else {
            providerJobType = this.props.jobTypes.find((jobType) => {
                return jobType.id === this.props.job.job_type_id;
            });
            providerJobTypePrice = providerJobType.provider_default_price || 0;
        }

        this.setState({
            providerJobTypePrice: providerJobTypePrice,
        });

        return providerJobTypePrice;
    };

    calculateTotalPrice = (jobTypePrice, providerJobTypePrice) => {
        let totalPrice = jobTypePrice * this.state.quantity;
        let providerTotalPrice = providerJobTypePrice * this.state.provider_quantity;

        if (this.state.selectedExtras) {
            this.state.selectedExtras.forEach((extra) => {
                totalPrice += extra.price * (extra.quantity || 1);
                providerTotalPrice += Number(extra.providerPrice) * Number(extra.provider_quantity || 0);
            });
        }

        this.setState({
            totalPrice,
            providerTotalPrice,
        });
    };

    handleDateChange = (date, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];
        this.setState({ [name]: date, errors: errorsObject });
    };

    handleChange = (e) => {
        let { name, value, type } = e.target;

        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (type === 'checkbox') {
            value = this.state[name] === 'yes' ? 'no' : 'yes';
        }

        this.setState(
            {
                [name]: value,
                errors: errorsObject,
            },
            () => {
                if (name === 'provider_quantity' || name === 'quantity') {
                    this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
                }
            }
        );
    };

    handleMultiSelectChange = (value, type) => {
        let extras = [];

        if (value !== null && typeof value !== 'undefined' && value.length > 0) {
            extras = [...value];

            if (!extras[extras.length - 1].hasOwnProperty('quantity')) {
                extras[extras.length - 1].quantity = 1;
            }

            if (
                !extras[extras.length - 1].hasOwnProperty('provider_quantity') ||
                extras[extras.length - 1].provider_quantity === ''
            ) {
                extras[extras.length - 1].provider_quantity = 1;
            }
        }
        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
            }
        );
    };

    handleExtraQtyChange = (e, extra, type) => {
        let extras = [...this.state[type]];

        let extraIndex = extras.findIndex((ex) => ex.value === extra.value);

        extras[extraIndex][e.target.name] = e.target.value;

        if (e.target.name === 'quantity') {
            extras[extraIndex]['provider_quantity'] = e.target.value;
        }

        if (extra.singular) {
            extras[extraIndex][e.target.name] = e.target.value;
        }

        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
            }
        );
    };

    handleCustomPriceChange = (e) => {
        let { name, value } = e.target;

        const numericValue = Number(value); // key fix

        let custom_price, custom_price_with_vat;

        if (name === 'custom_price') {
            custom_price = numericValue;
            custom_price_with_vat = +(numericValue * 1.2).toFixed(2);
        } else {
            custom_price_with_vat = numericValue;
            custom_price = +(numericValue / 1.2).toFixed(2);
        }

        this.setState({
            custom_price,
            custom_price_with_vat,
        });
    };

    handleProviderCustomPriceChange = (e) => {
        const { name, value } = e.target;
        const numericValue = parseFloat(value) || 0;

        if (name === 'provider_custom_price') {
            this.setState({
                provider_custom_price: numericValue,
                provider_custom_price_with_vat: +(numericValue * 1.2).toFixed(2),
            });
        } else {
            this.setState({
                provider_custom_price_with_vat: numericValue,
                provider_custom_price: +(numericValue / 1.2).toFixed(2),
            });
        }
    };

    onDrop = (acceptedFiles, name) => {
        let oldFiles = [...this.state[name]];
        let files = oldFiles.concat(acceptedFiles);

        this.setState({
            [name]: files,
        });
    };

    removeFile = (file, index, name) => {
        let acceptedFiles = [...this.state[name]];
        acceptedFiles.splice(index, 1);
        this.setState({
            [name]: acceptedFiles,
        });
    };

    onDropReject = (rejectedFiles, name) => {
        this.setState({
            rejectedFiles: { [name]: 'Photo size should be less than 2mb' },
        });
    };

    handleSearchableSelectChange = (e, name) => {
        this.setState({
            [name]: e,
        });
    };

    removeExistingMedia = (imageId) => {
        window.swal
            .fire({
                title: `Delete photo?`,
                text: `Are you sure you want to delete photo??`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: `Delete`,
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                    url: `/jobs/${this.props.job.id}/dtn/media/${imageId}`,
                    dataType: 'json',
                    type: 'delete',
                    success: () => {
                        location.reload();
                    },
                });
            });
    };
    onSubmit = async (e) => {
        e.preventDefault();

        this.setState({ errors: {} });
        const success = await this.saveDtn(true);

        if (!success) {
            toastr.error('Please save recycled waste before continuing.');
        }
    };
    saveDtn = async (shouldReload = true) => {
        try {
            if (this.recycledWasteRef.current) {
                this.setState({ savingRecycledWaste: true });

                try {
                    const saved = await this.recycledWasteRef.current.save();
                    this.setState({ recycledWasteSaved: saved });
                } catch (err) {
                    console.error('❌ Error saving recycled waste', err);
                } finally {
                    this.setState({ savingRecycledWaste: false });
                }
            }

            if (this.props.dtn.id) {
                await this.onSubmitValidateUpdate(shouldReload);
            } else {
                await this.onSubmitValidateStore(shouldReload);
            }

            return true;
        } catch (e) {
            return false;
        }
    };

    onSubmitValidateStore = async (shouldReload = true) => {
        if (!this.validateForm()) return false;

        this.setState({ loading: true });

        const formData = this.mapInputsToFormData();

        try {
            const res = await this.dtnService.storeDtn(this.props.job.id, formData);
            this.setState({ loading: false });
            toastr.success('Wtn was successfully saved');
            if (shouldReload) location = this.props.editRoute;
            return true;
        } catch (err) {
            this.setState({ loading: false });
            toastr.error('There was a problem while submitting the form. Please try again.');
            throw err;
        }
    };

    onSubmitValidateUpdate = async (shouldReload = true) => {
        if (!this.validateForm()) return false;

        this.setState({ loading: true });

        const formData = this.mapInputsToFormData();

        const oldProviderQuantity = parseInt(this.props.job.provider_quantity, 10) || 0;
        const newProviderQuantity = parseInt(formData.get('provider_quantity'), 10) || oldProviderQuantity;
        const providerJobTypePrice = parseFloat(this.state.providerJobTypePrice) || 0;
        const newProviderTotalPrice = providerJobTypePrice * newProviderQuantity;

        formData.append('new_provider_total_price', newProviderTotalPrice);
        formData.append('_method', 'PATCH');

        try {
            const res = await this.dtnService.updateDtn(this.props.job.id, formData);
            this.setState({ loading: false });
            toastr.success('Wtn was successfully edited');
            if (shouldReload) window.location.reload();
            return true;
        } catch (err) {
            this.setState({ loading: false });
            toastr.error('There was a problem while submitting the form. Please try again.');
            throw err;
        }
    };

    validateForm = () => {
        let errors = {};
        const fields = [
            'address',
            'postcode',
            'collection_date',
            'before_loading_waste',
            'after_loading_waste',
            'waste_contained',
            'waste_collected',
            'waste_description',
            'waste_volume',
        ];

        if (this.state.price_quoted === 'yes') {
            fields.push('custom_price');
        }

        if (this.state.provider_price_quoted === 'yes') {
            fields.push('provider_custom_price');
        }

        // if (!this.props.dtn.id) {
        //     fields.push('route_started');
        //     fields.push('route_arrived');
        //     fields.push('first_operative');
        //     fields.push('job_completed');
        // }

        fields.map((field) => {
            if (this.state[field] === '' || this.state[field] === undefined) {
                errors[field] = `${snakeCaseToTitle(field)} field is required`;
            }
        });

        if (!this.state.tipOff || !this.state.tipOff.value) {
            errors.tipOff = 'Select tip off field is required';
        }

        this.setState({ errors: errors });
        return Object.keys(errors).length === 0;
    };

    mapInputsToFormData = () => {
        let formData = new FormData();
        const mappable = [
            'address',
            'postcode',
            'collection_date',
            'before_loading_waste',
            'after_loading_waste',
            'waste_contained',
            'waste_collected',
            'waste_description',
            'waste_volume',
            'job_notes',
            'selectedExtras',
            'provider_quantity',
            'quantity',
            'admin_notes',
            'sla',
            'purchase_order_number',
            'purchase_order_total',
            'custom_price',
            'price_quoted',
            'provider_price_quoted',
            'provider_custom_price',
            'created_by',
        ];

        // if (!this.props.dtn.id) {
        //     mappable.push('route_started');
        //     mappable.push('route_arrived');
        //     mappable.push('job_completed');
        // }

        formData.append('job_extras', JSON.stringify(this.state.selectedExtras));
        this.state.images_before
            ? this.state.images_before.forEach((image) => formData.append('images_before[]', image))
            : '';
        this.state.images_after
            ? this.state.images_after.forEach((image) => formData.append('images_after[]', image))
            : '';
        this.state.van_images_before
            ? this.state.van_images_before.forEach((image) => formData.append('van_images_before[]', image))
            : '';
        this.state.van_images_after
            ? this.state.van_images_after.forEach((image) => formData.append('van_images_after[]', image))
            : '';
        this.state.customer_signature ? formData.append('customer_signature', this.state.customer_signature[0]) : '';
        formData.append('tip_off_id', this.state.tipOff.value || '');
        if (!this.props.dtn.id) {
            formData.append('first_operative', this.state.first_operative.value || '');
            formData.append('second_operative', this.state.second_operative.value || '');
        }
        formData.append('manager_review', this.state.manager_review === 'yes' ? 1 : 0);
        formData.append('manager_review_reason', this.state.manager_review_reason);

        mappable.forEach((input) => {
            if (
                input === 'collection_date' ||
                input === 'route_started' ||
                input === 'route_arrived' ||
                input === 'job_completed'
            ) {
                formData.append(input, this.state[input] ? moment(this.state[input]).format('YYYY/MM/DD HH:mm') : '');
                return;
            }
            if (input === 'before_loading_waste' || input === 'after_loading_waste') {
                formData.append(input, this.state[input] ? moment(this.state[input]).format('HH:mm') : '');
                return;
            }
            formData.append(input, this.state[input]);
        });

        return formData;
    };

    disableStatusButtons = () => {
        this.setState({
            disable_status_buttons: true,
        });
    };

    render() {
        // Determine if the "Mark as Completed" button should be disabled
        const recycledWasteLocked =
            this.state.customerUsesRecycling &&
            (!this.state.hasRecycledWaste || !this.state.recycledWasteValid || this.state.savingRecycledWaste);

        const currentJobType = this.props.jobTypes.find((jobType) => jobType.id === this.props.job.job_type_id);

        const isSmartSkip = currentJobType && currentJobType.name && currentJobType.name.toLowerCase() === 'smart skip';

        return (
            <Fragment>
                <form onSubmit={this.onSubmit} className="transform-text">
                    <CustomerDetails
                        customer={this.props.job.customer.name}
                        customer_contact={this.props.job.contact.first_name + ' ' + this.props.job.contact.last_name}
                        job_source={this.props.job_source ? this.props.job_source.job_source : ''}
                        purchase_order_number={this.state.purchase_order_number}
                        purchase_order_total={this.state.purchase_order_total}
                        sla={this.state.sla}
                        department={this.props.job.contact ? this.props.job.contact.department.name : ''}
                        handleChange={this.handleChange}
                    />

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Job Details</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-4">
                            <FormInputText
                                type="text"
                                name="created_by"
                                label="Created by"
                                value={this.state.created_by}
                                classes="form-control"
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <FormInputText
                                type="text"
                                name="address"
                                label="Address line 1"
                                value={this.state.address}
                                classes={this.state.errors.address ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.address}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <FormInputText
                                type="text"
                                name="postcode"
                                label="Postcode"
                                value={this.state.postcode}
                                classes={this.state.errors.postcode ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.postcode}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-4">
                            <SearchableSelect
                                name="tip_offs"
                                options={this.props.tipOffOptions}
                                classes={this.state.errors.tipOff ? 'is-invalid' : ''}
                                value={this.state.tipOff}
                                handleChange={(e) => this.handleSearchableSelectChange(e, 'tipOff')}
                                label="Select tip off"
                            />
                            {this.state.errors.tipOff && <FormError error={this.state.errors.tipOff} />}
                        </div>
                        <div className="form-group col-md-4">
                            <label>Collection date</label>
                            <DatePicker
                                className={
                                    this.state.errors.collection_date ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="collection date"
                                selected={this.state.collection_date || null}
                                onChange={(date) => this.handleDateChange(date, 'collection_date')}
                                dateFormat="dd/MM/yyyy"
                            />
                            <FormError error={this.state.errors.collection_date} />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Time before loading the waste</label>
                            <DatePicker
                                className={
                                    this.state.errors.before_loading_waste ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="time before loading the waste"
                                selected={this.state.before_loading_waste || null}
                                onChange={(date) => this.handleDateChange(date, 'before_loading_waste')}
                                dateFormat="HH:mm"
                                timeIntervals={15}
                                showTimeSelect
                                showTimeSelectOnly
                            />
                            <FormError error={this.state.errors.before_loading_waste} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-4">
                            <label>Time after loading the waste</label>
                            <DatePicker
                                className={
                                    this.state.errors.after_loading_waste ? 'form-control is-invalid' : 'form-control'
                                }
                                placholderText="time after loading the waste"
                                selected={this.state.after_loading_waste || null}
                                onChange={(date) => this.handleDateChange(date, 'after_loading_waste')}
                                dateFormat="HH:mm"
                                timeIntervals={15}
                                showTimeSelect
                                showTimeSelectOnly
                            />
                            <FormError error={this.state.errors.after_loading_waste} />
                        </div>
                        <div className="form-group col-md-4 hidden">
                            <FormInputNumber
                                type="number"
                                label="Quantity"
                                name="quantity"
                                step="1"
                                min="0"
                                classes="form-control"
                                value={this.state.quantity}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                label="Provider quantity"
                                name="provider_quantity"
                                step="1"
                                min="0"
                                classes="form-control"
                                value={this.state.provider_quantity}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>

                    {this.props.previousFollowOnDescription ? (
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Previous job notes</label>
                                <textarea
                                    name="previous_job_notes"
                                    id="previous_job_notes"
                                    className="form-control"
                                    value={this.props.previousFollowOnDescription}
                                    rows={5}
                                    disabled
                                >
                                    {this.props.previousFollowOnDescription}
                                </textarea>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}

                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Admin notes</label>
                            <textarea
                                className="form-control"
                                name="admin_notes"
                                id="admin_notes"
                                value={this.state.admin_notes}
                                onChange={this.handleChange}
                                placeholder="Admin notes..."
                                rows="5"
                            ></textarea>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Job notes</label>
                            <textarea
                                className="form-control"
                                name="job_notes"
                                id="job_notes"
                                value={this.state.job_notes}
                                onChange={this.handleChange}
                                placeholder="Job notes..."
                                rows="5"
                            ></textarea>
                        </div>
                    </div>

                    {this.state.manager_review === 'yes' ? (
                        <div className="row">
                            <div className="col-12">
                                <FormInputText
                                    label="Manager Review Reason"
                                    name="manager_review_reason"
                                    type="text"
                                    classes={
                                        this.state.errors.manager_review_reason
                                            ? 'form-control is-invalid'
                                            : 'form-control'
                                    }
                                    value={this.state.manager_review_reason}
                                    handleChange={this.handleChange}
                                    error={this.state.errors.manager_review_reason}
                                />
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {this.props.job.manager_review_flag_reason ? (
                        <div className="row">
                            <div className="col-12">
                                <p>Manager Review Flagged by: {this.props.job.manager_review_flag_reason}</p>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    <div className="row">
                        <div className="col-12">
                            <FormCheckbox
                                name="manager_review"
                                label="MANAGER REVIEW"
                                checked={this.state.manager_review === 'yes'}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>

                    {!this.props.dtn.id ? (
                        <OperativeDetails
                            first_operative={this.state.first_operative}
                            second_operative={this.state.second_operative}
                            second_member_id={this.state.second_member_id}
                            route_started={this.state.route_started}
                            route_arrived={this.state.route_arrived}
                            job_completed={this.state.job_completed}
                            errors={this.state.errors}
                            operatives={this.props.operatives}
                            handleDateChange={this.handleDateChange}
                            handleChange={this.handleChange}
                            handleSearchableSelectChange={this.handleSearchableSelectChange}
                        />
                    ) : (
                        ''
                    )}

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Waste collected</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_contained"
                                label="How was the waste contained:"
                                value={this.state.waste_contained}
                                classes={this.state.errors.waste_contained ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.waste_contained}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_description"
                                label="Description of the waste being collected:"
                                value={this.state.waste_description}
                                classes={
                                    this.state.errors.waste_description ? 'form-control is-invalid' : 'form-control'
                                }
                                error={this.state.errors.waste_description}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_collected"
                                label="Estimated weight of waste collected(Kg):"
                                value={this.state.waste_collected}
                                classes={this.state.errors.waste_collected ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.waste_collected}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_volume"
                                label="Total waste collected(CY):"
                                value={this.state.waste_volume}
                                classes={this.state.errors.waste_volume ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.waste_volume}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>

                    {isSmartSkip && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="alert alert-warning">
                                    ⚠️ Please ensure the provider quantity matches the total waste collected
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormMultiSelect
                                label="Job Extras"
                                options={this.state.extrasOptions}
                                handleMultiSelectChange={(value) =>
                                    this.handleMultiSelectChange(value, 'selectedExtras')
                                }
                                classes={'form-control'}
                                prefixes={this.state.selectedExtras}
                            />
                        </div>
                    </div>

                    <JobExtras
                        extras={this.state.selectedExtras}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType={'selectedExtras'}
                        extrasPrices={this.props.jobExtras}
                        serviceProvider={this.props.serviceProvider}
                        providerExtrasType={'job_extras'}
                        dtn={true}
                    />

                    <PricingDetails
                        skips={this.state.skips}
                        extras={this.state.selectedExtras}
                        totalPrice={this.state.totalPrice}
                        timeSpentWorking={this.props.timeSpentWorking}
                        laborCost={this.props.laborCost}
                        providerTotalPrice={this.state.providerTotalPrice}
                        price_quoted={this.state.price_quoted}
                        custom_price={this.state.custom_price}
                        custom_price_with_vat={this.state.custom_price_with_vat}
                        provider_price_quoted={this.state.provider_price_quoted}
                        provider_custom_price={this.state.provider_custom_price}
                        provider_custom_price_with_vat={this.state.provider_custom_price_with_vat}
                        handleProviderCustomPriceChange={this.handleProviderCustomPriceChange}
                        handleChange={this.handleChange}
                        handleCustomPriceChange={this.handleCustomPriceChange}
                        additionalCosts={this.state.additionalCosts}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Photos before clearing"
                        name="images_before"
                        acceptedFiles={this.state.images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.images_before}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Photos after clearing"
                        name="images_after"
                        acceptedFiles={this.state.images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.images_after}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos before clearing"
                        name="van_images_before"
                        acceptedFiles={this.state.van_images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.van_images_before}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos after clearing"
                        name="van_images_after"
                        acceptedFiles={this.state.van_images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.van_images_after}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DriverSignature imagePath={this.props.signaturePath} driver={this.props.driver} />

                    <DtnPhotos
                        title="Customer signature"
                        name="customer_signature"
                        acceptedFiles={this.state.customer_signature}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.customer_signature}
                        multiple={false}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    {this.state.customerUsesRecycling && this.props.dtn?.id && (
                        <div className="row">
                            <div className="col-md-12">
                                <RecycledWasteChart
                                    ref={this.recycledWasteRef}
                                    jobId={this.props.job.id}
                                    onValidityChange={(isValid) => {
                                        if (this.state.recycledWasteValid !== isValid) {
                                            this.setState({
                                                recycledWasteValid: isValid,
                                            });
                                        }
                                    }}
                                    onSaved={() => {
                                        this.setState({
                                            savingRecycledWaste: false,
                                            hasRecycledWaste: true, // this unlocks the "Mark as Completed" button
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {this.state.customerUsesRecycling &&
                        this.props.dtn?.id &&
                        this.state.hasRecycledWaste === false && (
                            <div className="alert alert-warning mt-3">
                                ⚠️ This job does not have any recycled waste recorded! This job cannot be completed unti
                                waste is recorded.
                            </div>
                        )}

                    <div className="row">
                        <div className="col-md-12">
                            <SubmitButton
                                buttonText={this.props.dtn.id ? 'Edit WTN' : 'Create WTN'}
                                loading={this.state.loading}
                                style={{ width: 200, marginTop: 20 }}
                            />
                            {this.props.job.status !== 'allocated' && (
                                <a
                                    href={this.props.downloadUrl}
                                    className="btn btn-cw-green"
                                    style={{ width: 200, marginTop: 20, marginLeft: 15 }}
                                >
                                    Download WTN
                                </a>
                            )}

                            {this.props.job.status === 'done' && (
                                <StatusButtons
                                    job={this.props.job}
                                    jobId={this.props.job.id}
                                    disabled={this.state.disable_status_buttons || recycledWasteLocked}
                                    disableStatusButtons={this.disableStatusButtons}
                                    saveDtn={this.saveDtn}
                                    user={this.props.currentUser}
                                />
                            )}
                        </div>
                    </div>
                </form>
            </Fragment>
        );
    }
}

if (document.getElementById('edit-volume')) {
    const element = document.getElementById('edit-volume');
    ReactDOM.render(
        <EditVolumeJobs
            job={JSON.parse(element.dataset.job)}
            dtn={JSON.parse(element.dataset.dtn)}
            type={JSON.parse(element.dataset.type)}
            jobExtras={JSON.parse(element.dataset.job_extras)}
            media={JSON.parse(element.dataset.media)}
            signaturePath={element.dataset.signature_path}
            jobTypes={JSON.parse(element.dataset.job_types)}
            timeSpentWorking={element.dataset.time_spent_working}
            laborCost={element.dataset.labor_cost}
            tipOffOptions={JSON.parse(element.dataset.tip_off_options)}
            downloadUrl={element.dataset.download_url}
            serviceProvider={JSON.parse(element.dataset.service_provider)}
            driver={element.dataset.driver !== null ? JSON.parse(element.dataset.driver) : null}
            operatives={element.dataset.operatives ? JSON.parse(element.dataset.operatives) : []}
            editRoute={element.dataset.edit_route}
            currentUser={JSON.parse(element.dataset.currentUser)}
            hasRecycledWaste={element.dataset.hasRecycledWaste ? JSON.parse(element.dataset.hasRecycledWaste) : false}
            customerUsesRecycling={
                element.dataset.customerUsesRecycling ? JSON.parse(element.dataset.customerUsesRecycling) : false
            }
            additionalCosts={JSON.parse(element.dataset.additional_costs)}
        />,
        element
    );
}

export default EditVolumeJobs;
